export const COMP_PLAN_READ_ONLY_TOOLTIP =
  'Compensation plans are read-only here. Changes take effect at the next plan review window — contact your account executive to request one.';

export const COMP_PLAN_EFFECTIVE_PREFIX = 'eff';

// Relabeled from "next window" (DEV-3636, counsel-approved): the label must not
// imply a committed future change date — it reflects an estimated review window only.
export const COMP_PLAN_NEXT_WINDOW_PREFIX = 'Next plan review window';

// Counsel-approved disclaimer (DEV-3636), rendered as visible, non-collapsible
// text on/near the comp-plan chip alongside its next-review window.
export const COMP_PLAN_DISCLAIMER =
  'This comp plan and the next-review window shown are for informational reference only. They do not constitute a binding commitment to the displayed rate or to any future rate change. Comp plans may be modified subject to applicable notice requirements. Contact your Account Executive for questions about your current arrangement.';
